var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-exception"},[_c('div',{staticClass:"app-exception__img app-exception__img--500"}),_c('h1',[_vm._v("500")]),_c('p',[_vm._v("抱歉，服务器出错了")])])
}]

export { render, staticRenderFns }